import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useEmailApiClient } from '@/api/clients/useEmailApiClient.util.ts';
import { useUserContext } from '@/contexts/userContext/User.context.ts';

type Req = {
  attachmentId: string;
  emailId: string;
};

type Return = {
  deleteAttachment: (req: Req) => Promise<void>;
  isDeletingAttachment: boolean;
  isErrorDeletingAttachment: boolean;
};

export const useDeleteAttachment = (): Return => {
  const { emailUpdateApi } = useEmailApiClient();
  const { userId } = useUserContext();

  const { isError, isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    mutationFn: async req => {
      const { data } = await emailUpdateApi.deleteAttachment(userId, req.emailId, req.attachmentId);
      return data;
    },
  });

  return {
    deleteAttachment: mutateAsync,
    isDeletingAttachment: isPending,
    isErrorDeletingAttachment: isError,
  };
};
